'use client'

import { Button } from '@7f-ui/components/button/button'
import type { Cart } from '@feat/feat-cart/cart'
import { trackClickCtaEvent } from '@feat/feat-tracking/cta'
import { shopTestId } from '@utils/utils-shop-test-ids'
import Link from 'next/link'
import type { PropsWithChildren } from 'react'

type SubmitButtonProps = {
  cart: Cart
  checkoutHref: string
}

export const CartCTABoxContent = Object.assign(Root, {
  SubmitButton,
})

function Root({ children }: PropsWithChildren) {
  return <div className="flex flex-col gap-4 text-primary">{children}</div>
}

function SubmitButton({ cart, checkoutHref }: SubmitButtonProps) {
  return (
    <Button
      as={Link}
      href={checkoutHref}
      full
      disabled={!cart.bookable}
      data-testid={shopTestId('CTABox.checkout-cta')}
      onClick={() => {
        trackClickCtaEvent({
          action: 'click - checkout_cta_clicked',
          type: 'checkout',
          item_count: cart.items.all.length,
        })
      }}
    >
      Weiter
    </Button>
  )
}
